export default __webpack_public_path__ + "static/media/adpi.6be20c44.svg";